import { useContext } from 'react';

import { GaugeChartConfigContext } from '../contexts/GaugeChartConfigContext.js';

export const useGaugeChartConfigContext = () =>
  useContext(GaugeChartConfigContext);
